export default __webpack_public_path__ + "static/media/fudge.6d22448f.png";